import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { WindowRefService } from '../../core/services/windowRef.service';

@Directive({
  selector: '[appTooltip]',
  standalone: true,
})
export class TooltipDirective implements AfterViewInit {
  constructor(private el: ElementRef, private windowRefService: WindowRefService) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      let selector = this.el.nativeElement;
      if (this.el.nativeElement.id) {
        selector = `#${this.el.nativeElement.id}`;
      }

      this.windowRefService.AJS.$(selector).tooltip();
    }, 300);
  }
}
